import { SVGProps, Ref, forwardRef } from 'react';

export const MagnifierOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M.496 7.247c0-3.375 1.688-6.75 6.75-6.75s6.75 3.375 6.75 6.75c0 1.6-.379 3.2-1.318 4.441L15.5 14.51l-.99.99-2.816-2.816c-1.045.81-2.495 1.313-4.448 1.313-5.062 0-6.75-3.375-6.75-6.75m1.4 0c0-1.48.373-2.81 1.153-3.745.742-.89 2.003-1.605 4.197-1.605s3.456.715 4.198 1.605c.78.936 1.152 2.265 1.152 3.745s-.372 2.809-1.152 3.744c-.742.89-2.003 1.606-4.198 1.606-2.194 0-3.455-.716-4.197-1.606-.78-.935-1.153-2.265-1.153-3.744"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
MagnifierOutlinedSize16Glyph.displayName = 'MagnifierOutlinedSize16Glyph';
